module.exports = __webpack_public_path__ + "media/bg.f1fa4961.mp3";